import type { Leadership } from "../types/leadership";

export const leadership: Leadership[] = [
  {
    slug: "shelter-them-rwanda",
    role: "Website Designer & Maintainer",
    organization: "Shelter Them Rwanda",
    date: "Jun 2025 - Present",
    description:
      "Redesigned 20+ pages of the organization's site as a volunteer: new navigation, responsive layouts, SEO and accessibility fixes. Engagement rose 22% and organic traffic 35% within 6 months, with about 99% uptime.",
  },
  {
    slug: "speed-networking-mentor",
    role: "Speed Networking Mentor",
    organization: "Toronto Tech Week's ScaleUp — Humber Downtown",
    date: "May 2026",
    description:
      "Mentored early-career job seekers on resumes, interviews, and networking as a speed-networking mentor.",
  },
  {
    slug: "humber-downtown",
    role: "Student Ambassador & Idea Lab Assistant",
    organization: "Humber Downtown — International Graduate School",
    date: "Sep 2025 — Dec 2025",
    description:
      "Supported student services and the Idea Lab — helping students and staff with creative technology and digital media tools, and building campus community.",
  },
  {
    slug: "student-advisory-committee",
    role: "Student Advisory Committee Member",
    organization: "Humber Polytechnic",
    date: "Apr 2025 - Jul 2025",
    description:
      "Represented student feedback and priorities as part of the campus advisory committee.",
  },
  {
    slug: "orientation-lead",
    role: "Orientation Lead",
    organization: "Humber Downtown — International Graduate School",
    date: "Aug 2025",
    description:
      "Welcomed and onboarded new students during orientation week, helping them settle into campus life.",
  },
  {
    slug: "community-connector",
    role: "Community Connector",
    organization: "Humber Downtown — International Graduate School",
    date: "Jan 2025 - Aug 2025",
    description:
      "Hosted Community Hours and helped students discover campus resources and support services.",
  },

  {
    slug: "hack-the-6ix",
    role: "Hackathon Volunteer",
    organization: "Hack the 6ix",
    date: "Jul 2025",
    description:
      "Volunteered at the Hack the 6ix hackathon, supporting the event after competing in others as a participant.",
  },
];
